import client from '../utils/client';
import { packagesUrl } from '../store/constants/api';
import { cookieConstants } from "../store/constants";
import { Cookies } from "react-cookie";

const cookies = new Cookies();

export const packageService = {
  packagesList,
  addPackage,
  getPackage,
  updatePackage
}

function packagesList(pageID, perPage) {
  return client.get(packagesUrl + '?page=' + pageID + '&per_page=' + perPage)
    .then((response) => {
      console.log(response)
      return response
    })
    .catch(handleResponse);
}

function addPackage(formDate) {
  return client.post(packagesUrl + '/create', formDate)
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function getPackage(packageID) {
  return client.get(packagesUrl + '/' + packageID + '/show')
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function updatePackage(formDate) {
  return client.post(packagesUrl + '/update', formDate)
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function logout() {
  cookies.remove(cookieConstants.TOKEN, { path: "/" });
  cookies.remove(cookieConstants.USER, { path: "/" });
}

function handleResponse(response) {
  response = response.response
  var data = response.data;
  if (!response.ok) {
    if (response.status === 401) {
      logout();
      window.location.reload(true);
    }
    const error = data.errors;
    return Promise.reject(error);
  }

  return data;
}